import { ISelectOptions } from "../../../types/inputs";
import { Button } from "../../Atoms/Button";
import { FileContainer } from "../../Atoms/FileContainer";
import { InputSwitch } from "../../Atoms/Inputs/InputSwitch";
import InputSingleFile from "../../Atoms/InputSingleFile";
import { SimpleSelect } from "../../Atoms/Selects/SimpleSelect";
import { Spinner } from "../../Atoms/Spinner";
import { SubTitle } from "../../Atoms/SubTitle";
import { TextArea } from "../../Atoms/TextArea";
import { Title } from "../../Atoms/Title";
import { useImpedimentRegister } from "./useImpedimentRegister";
import * as S from "./styles";

export const ImpedimentRegisterTemplate = () => {
    const { isLoading,
        registro,
        motivosOptions,
        form,
        setForm,
        files,
        fileLoading,
        handleFileChange,
        handleFileRemove,
        handleSubmit } = useImpedimentRegister();

    return (
        <S.Container>
            <S.Wrapper>
                <Title>Registrar Impedimento</Title>
            
                <S.FormComunicacaoAtraso onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit(form);
                }}>
                    <div>
                        <SimpleSelect
                            isDisabled={form?.outroMotivo}
                            label="Motivo"
                            options={motivosOptions}
                            onChange={(e: ISelectOptions) =>
                                setForm((prev) => ({ 
                                    ...prev, 
                                    uuidMotivo: e?.value, 
                                    outroMotivo: false 
                                }))
                            }
                            value={
                                motivosOptions.find((e) => e.value === form?.uuidMotivo) || null
                            }
                        />
                    </div>

                    <div>
                        <InputSwitch
                            label="Outro motivo"
                            id="ativo"
                            checked={form?.outroMotivo}
                            onChange={(e) => {
                                setForm((prev) => ({ ...prev, outroMotivo: e?.target?.checked }));
                                e?.target?.checked && setForm((prev) => ({ ...prev, uuidMotivo: null }));
                            }}
                        />
                    </div>

                    <div>
                        <TextArea 
                            label="Observação"
                            id="textarea"
                            value={form?.observacao}
                            onChange={(e) => setForm((prev) => ({ ...prev, observacao: e?.target?.value }))}
                        />
                    </div>

                    <div>
                        <SubTitle className="mb-3">Anexos</SubTitle>
                        <div className="grid grid-cols-1 gap-3">
                            <div>
                            {fileLoading ? (
                                <div className="h-16 w-full">
                                {" "}
                                <Spinner size="small" show={fileLoading} />
                                </div>
                            ) : (
                                <InputSingleFile onChange={handleFileChange} />
                            )}
                            </div>
                            <div className="flex gap-3 flex-wrap">
                            {files.length > 0 &&
                                files.map((f) => (
                                <FileContainer
                                    key={f.uuid}
                                    name={f?.fileName}
                                    size={f?.size}
                                    handleClick={() => handleFileRemove(f?.uuid)}
                                />
                                ))}
                            </div>
                        </div>
                    </div>

                    <div>
                        <Button>Avançar</Button>
                    </div>
                </S.FormComunicacaoAtraso>
            </S.Wrapper>
        </S.Container>
    );
};